import { compose } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { type ComponentType } from 'react';
import {
  byIsLoading,
  byInitialValues,
} from 'routes/ResultList/modules/resultList';
import { onSubmit } from '../searchRibbon';
import SearchRibbonForm from '../SearchRibbonForm';

const mapStateToProps = (state: any) => ({
  isLoading: byIsLoading(state),
  headline: state.htmlMeta.header,
  initialValues: byInitialValues(state),
  totalHits: state.resultList.totalHits,
});

const mapDispatchToProps = (dispatch, { history }: any) => ({
  handleSubmit: (values: any) => dispatch(onSubmit(values, history)),
});

const SearchRibbonContainer = compose<ComponentType>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(SearchRibbonForm);

export default SearchRibbonContainer;
